/** Ключ localStorage для ручного фона (экран «Настройки»). */
export const APP_LOADING_BG_KEY = "appLoadingBackgroundImage";

export function applyLoadingBackground(imageUrl) {
  if (typeof document === "undefined") return;
  if (!imageUrl) {
    document.documentElement.style.removeProperty("--app-loading-bg-image");
    return;
  }
  // JSON.stringify yields a safe double-quoted string for use inside url(...), avoiding broken CSS
  // when the URL contains quotes, spaces, or ")".
  const safe = JSON.stringify(String(imageUrl).trim());
  document.documentElement.style.setProperty("--app-loading-bg-image", `url(${safe})`);
}

export function applyLoadingBackgroundFromStorage() {
  if (typeof window === "undefined") return;
  const savedImage = localStorage.getItem(APP_LOADING_BG_KEY);
  if (!savedImage) {
    document.documentElement.style.removeProperty("--app-loading-bg-image");
    return;
  }
  applyLoadingBackground(savedImage);
}
